import _ from "lodash";
import {
  fetchAddOnsMetadata,
  fetchAddOnsList,
  fetchPackagesMetadata,
  fetchPackagesList,
  initPackageSearch,
  pollPackageSearch,
  fetchPackagePrice,
} from "../../api";

import {
  PRICE_SEARCH_FORM_CHANGE,
  PRICE_SEARCH_FORM_SEARCHING,
  PRICE_SEARCH_FORM_IDLE,
  TOUR_PRICE_INFO_RESET,
  TOURS_METADATA_SAVE,
  TOUR_SEARCH_FORM_CHANGE,
  TOURS_LIST_SAVE,
  TOURS_LIST_LOADING,
  TOURS_LIST_IDLE,
  TOUR_INIT_SEARCH_DATA_SAVE,
  PACKAGES_METADATA_SAVE,
  LIST_ORDER_CHANGE,
  TOUR_SEARCH_DATA_SAVE,
  TOUR_SEARCH_INIT_SEARCH_STATUSES,
  PACKAGE_SERVICE_SET_SEARCH_STATUS,
  TOUR_SEARCH_FORM_UPDATE,
  TOUR_SEARCH_FORM_RESET,
  TOUR_PRICE_INFO_SAVE,
} from "./types";

import {
  backendAccSearchInitiatedSelector,
  backendFlightsSearchInitiatedSelector,
  backendTransfersIsSearchingSelector,
  pkgTransfersRequiredSelector,
  accIsSearchingSelector,
  flIsSearchingSelector,
  pkgSearchSessionIdSelector,
  trfIsSearchingSelector,
  tripServicesListSelector,
} from "../../umbilical_hocs";
import { accommodationsSearchPoller } from "./accommodation_search";
import {
  createTransferPayloads,
  transferSearchResultsFetcher,
  transfersSearchInitiator,
} from "./transfers_search";
import { flightSearchResultsFetcher } from "./flights_search";
import { toast } from "react-toastify";

var api_key = import.meta.env.VITE_APP_WEBSITE_KEY;

export function changeSearchForm({ form }) {
  return { type: PRICE_SEARCH_FORM_CHANGE, form };
}

export function searchFormSearching() {
  return { type: PRICE_SEARCH_FORM_SEARCHING };
}

export function priceSearchFormIdle() {
  return { type: PRICE_SEARCH_FORM_IDLE };
}

export function resetPriceInfo() {
  return { type: TOUR_PRICE_INFO_RESET };
}

export const getAddOnDestinations = () => async (dispatch, getState) => {
  const state = getState();
  const {
    metadata: { source_entity },
  } = state.WebsiteMetadata;

  const metadata = await fetchAddOnsMetadata({ source_entity });

  if (metadata) {
    const { categories, destinations, duration } = metadata;

    dispatch({
      type: TOURS_METADATA_SAVE,
      categories,
      destinations,
      duration,
    });
  } else {
    //notify here.
  }
};

export function tourSearchFormReset() {
  return { type: TOUR_SEARCH_FORM_RESET };
}

export function tourSearchFormChange(key, value) {
  return { type: TOUR_SEARCH_FORM_CHANGE, key, value };
}

export function tourSearchFormUpdate({ form }) {
  return { type: TOUR_SEARCH_FORM_UPDATE, form };
}

export const saveToursList = (list, product_type) => {
  return { type: TOURS_LIST_SAVE, list, product_type };
};

export const toursSearch = (options) => async (dispatch, getState) => {
  const { theme = "" } = options;
  const state = getState();

  const {
    metadata: { source_entity, api_key, uid },
  } = state.WebsiteMetadata;

  const { destination_code, categories } = state.TourSearchForm;

  await dispatch(loadingToursList());

  try {
    const results = await fetchAddOnsList({
      destination_code,
      categories,
      source_entity,
      website_api_key: uid, // Temporary
    });

    results.forEach((res) => (res.product_type = "MI"));

    const validResults = results.filter((res) => {
      if (!theme) {
        return true;
      } else {
        return _.get(res, "themes", []).includes(theme);
      }
    });

    await dispatch(saveToursList(validResults, "MI"));
  } catch {
  } finally {
    dispatch(idleToursList());
  }
};

export const loadingToursList = () => {
  return { type: TOURS_LIST_LOADING };
};

export const idleToursList = () => {
  return { type: TOURS_LIST_IDLE };
};

// ============================= PACKAGES ============================

export const getPackagesMeta = () => async (dispatch, getState) => {
  const state = getState();
  const {
    metadata: { source_entity },
  } = state.WebsiteMetadata;

  const metadata = await fetchPackagesMetadata({ source_entity, api_key });

  if (metadata) {
    const { services, destinations, durations } = metadata;

    dispatch({
      type: PACKAGES_METADATA_SAVE,
      services,
      destinations,
      durations,
    });
  } else {
    //notify here.
  }
};

export const pkgSearch = (options) => async (dispatch, getState) => {
  const { redirect = true, history } = options;
  const state = getState();

  const {
    metadata: { source_entity },
  } = state.WebsiteMetadata;
  const { destination_code: destination_codes, services, durations } = state.TourSearchForm;

  await dispatch(loadingToursList());

  if (redirect) {
    history.push("/tours");
  }

  try {
    const results = await fetchPackagesList({
      destination_codes,
      services,
      durations,
      source_entity,
      api_key,
    });

    results.forEach((res) => (res["product_type"] = "PKG"));
    await dispatch(saveToursList(results, "PKG"));
  } catch {
  } finally {
    dispatch(idleToursList());
  }
};

export const packagePriceSearch = (reference) => async (dispatch, getState) => {
  const state = getState();

  const {
    metadata: { source_entity },
  } = state.WebsiteMetadata;
  const {
    date: start_date,
    adults,
    children,
    rooms: pax_setup,
    flight_origin,
  } = state.PriceSearchForm;

  if (!start_date) {
    toast.warning("Please select a valid date first.");
    return;
  }

  dispatch(searchFormSearching());

  const result = await initPackageSearch({
    api_key,
    reference,
    source_entity,
    adults,
    children,
    pax_setup,
    start_date,
    flight_origin,
  });

  if (!result) {
    dispatch(priceSearchFormIdle());
    toast.warning(
      "We couldn't initiate the price search process. Please try again later. We are sorry for the incovenience.",
      { duration: 5000 },
    );

    return;
  }

  const { session_id } = result;
  await dispatch({ type: TOUR_INIT_SEARCH_DATA_SAVE, session_id });
  setTimeout(() => dispatch(pollPackagePriceSearch({ reference, search_counter: 0 })), 3000);
};

const pollPackagePriceSearch =
  ({ reference, search_counter }) =>
  async (dispatch, getState) => {
    const state = getState();
    const {
      search_data: { session_id },
    } = state.TourPriceInfo;

    const result = await pollPackageSearch({ reference, session_id });
    await dispatch({ type: TOUR_SEARCH_DATA_SAVE, search_data: result });

    const isAccSearchInitiated = backendAccSearchInitiatedSelector(state);
    const isFlightSearchInitiated = backendFlightsSearchInitiatedSelector(state);

    if (isAccSearchInitiated === 1 && isFlightSearchInitiated === 1) {
      await dispatch({
        type: TOUR_SEARCH_INIT_SEARCH_STATUSES,
        srvs: ["accommodation", "flights"],
      });
      dispatch(flightSearchResultsFetcher());
      dispatch(accommodationsSearchPoller({ pollCount: 0 }));
      return;
    }

    if (search_counter > 15 && (isAccSearchInitiated !== 1 || isFlightSearchInitiated !== 1)) {
      dispatch(pkgFailedSearch());
      return;
    }

    setTimeout(
      () =>
        dispatch(
          pollPackagePriceSearch({
            reference,
            search_counter: search_counter + 1,
          }),
        ),
      3000,
    );
  };

export const pollPackageTransfersPriceSearch =
  ({ reference }) =>
  async (dispatch, getState) => {
    const state = getState();
    const {
      search_data: { session_id },
    } = state.TourPriceInfo;

    const result = await pollPackageSearch({ reference, session_id });

    if (!result) {
      dispatch(pkgFailedSearch());
      return;
    }

    const transfers = _.get(result, "search_statuses.transfers", []);
    if (transfers.length && transfers.every((trf) => trf.status >= 400)) {
      dispatch(pkgFailedSearch());
      return;
    }

    if (transfers.length > 0) {
      await dispatch({ type: TOUR_SEARCH_DATA_SAVE, search_data: result });
    }

    const isTransfersSearchInitiated = backendTransfersIsSearchingSelector(state);
    if (isTransfersSearchInitiated === 1) {
      dispatch(transferSearchResultsFetcher());
      return;
    }

    setTimeout(() => dispatch(pollPackageTransfersPriceSearch({ reference })), 3000);
  };

export const checkPackagePriceSearch = () => (dispatch, getState) => {
  const state = getState();
  const pkg_reference = state.TourDetails.details.reference;
  const pkg_session_id = pkgSearchSessionIdSelector(state);

  const accommodationsIsSearching = accIsSearchingSelector(state);
  const flightsIsSearching = flIsSearchingSelector(state);
  const transfersAreRequired = pkgTransfersRequiredSelector(state);
  var transfersIsSearching = 0;
  if (transfersAreRequired) {
    transfersIsSearching = trfIsSearchingSelector(state);
  }

  if (accommodationsIsSearching === 0 && flightsIsSearching === 0) {
    if (transfersAreRequired) {
      if (transfersIsSearching === 0) {
        dispatch(priceSearchFormIdle());
      } else if (transfersIsSearching === -1) {
        const payloads = createTransferPayloads(state);
        dispatch(transfersSearchInitiator({ payloads, pkg_session_id, pkg_reference }));
      } else {
        return;
      }
    }
  }

  if (accommodationsIsSearching === 0 && flightsIsSearching === 0 && transfersIsSearching === 0) {
    dispatch(pkgGetPrice());
  }
};

export const pkgUpdateServiceSearchStatus = ({ dest_order, srvType, status }) => {
  return {
    type: PACKAGE_SERVICE_SET_SEARCH_STATUS,
    srvType,
    dest_order,
    status,
  };
};

export const pkgFailedSearch = () => (dispatch) => {
  toast.warning(
    "We couldn't find price and/or availability for your request. We are sorry for the incovenience.",
    { duration: 5000 },
  );

  dispatch(resetPriceInfo());
  dispatch(priceSearchFormIdle());
};

export const savePriceInfo = (price_info) => {
  return { type: TOUR_PRICE_INFO_SAVE, price_info };
};

export const pkgGetPrice = () => async (dispatch, getState) => {
  const state = getState();
  const services = tripServicesListSelector(state, { noDoubleSrvs: true });

  const srv_payload = services.map((srv) => {
    const tmp = {
      type: srv.srvType,
      session_id: srv.service.session_id,
      service_uid: srv.service.uid,
    };

    if (srv.srvType === "ACC") {
      tmp["rooms"] = srv.service.rooms.map((r) => r.id);
      tmp["service_id"] = srv.service.metadata.id;
    }

    if (srv.srvType === "FL") {
      tmp["legs"] = {
        outbound: srv.service.legs[0].find((o) => o.selected).uid,
      };
      if (srv.service.legs.length > 1) {
        tmp.legs["inbound"] = _.last(srv.service.legs).find((o) => o.selected).uid;
      }
    }

    return tmp;
  });

  const payload = {
    services: srv_payload,
    session_id: state.TourPriceInfo.search_data.session_id,
  };
  const reference = state.TourDetails.details.reference;

  const result = await fetchPackagePrice({ reference, payload });
  if (!result) {
    dispatch(pkgFailedSearch());
    return;
  }

  dispatch(savePriceInfo(result));
};

// ==================== PACKAGES & TOURS FILTERING ===================

export const changeOrder = (ordering) => {
  return { type: LIST_ORDER_CHANGE, ordering };
};
